import type { PillProps } from './interfaces';
import styles from './Pill.module.scss';
import Icon from '../Icon/Icon';
import clsx from 'clsx';

const Pill = ({ title, onClose, isBoxOnGradient = false }: PillProps) => {
  return (
    <div
      className={clsx(styles.pill, {
        [styles.withGradient]: isBoxOnGradient,
      })}
      onClick={onClose}
    >
      <div
        className={clsx(styles.title, {
          [styles.withGradient]: isBoxOnGradient,
        })}
      >
        {title}
      </div>
      {onClose && (
        <Icon
          className={clsx(styles.icon, {
            [styles.withGradient]: isBoxOnGradient,
          })}
          variant={'action/close'}
          size="iconSize18"
        />
      )}
    </div>
  );
};

export default Pill;
